import { Expense, ExtendedReferencedExpenseAccount } from "@finway-group/shared/lib/models"
import { Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useIsExpenseAccountMandatory } from "../../../../../shared/hooks/expense.hooks"
import { useExpenseAccounts } from "../../../../../shared/hooks/expenseAccount.hooks"
import { checkIsExpenseAccountMandatoryForExpenseStatus, checkIsSplitExpenseAccountPartiallySet, isSplitPropertiesSame } from "../../../../../shared/utils/expense.utils"
import { doFilterSelect } from "../../../../../shared/utils/helper.utils"
import { getPopupAnchor } from "../../../../../shared/utils/popup.utils"

interface ExpenseAccountFieldProps {
    expense: Expense
    expenseAccount?: ExtendedReferencedExpenseAccount
    onChange: (value: string) => void
    isReadOnly?: boolean
    isInputDisabled?: boolean
    isLoading?: boolean
}
export const ExpenseAccountField = ({ isInputDisabled, isReadOnly, isLoading, expense, expenseAccount, onChange }: ExpenseAccountFieldProps) => {
    const { t } = useTranslation()
    const expenseAccounts = useExpenseAccounts()
    const isExpenseAccountMandatory = useIsExpenseAccountMandatory()
    const isExpenseAccountSet = expenseAccount || checkIsSplitExpenseAccountPartiallySet(expense)

    if (isExpenseAccountSet) {
        const isUniform = isSplitPropertiesSame(expense.splits)
        return (
            <li>
                <span className="title">{t("label:expense_account")}</span>
                <span className="text ml-16">
                    <p className="truncate">{expenseAccount && isUniform.expenseAccount ? `${expenseAccount.accountCode} - ${expenseAccount.accountName}` : t("label:splitted")}</p>
                </span>
            </li>
        )
    }

    if (isExpenseAccountMandatory && !isExpenseAccountSet && !isReadOnly) {
        const isRequired = checkIsExpenseAccountMandatoryForExpenseStatus({ expenseStatus: expense.status, isExpenseAccountMandatory })
        return (
            <li>
                <span className="w-1/2 title">
                    <div className={`flex ${isRequired ? "label-required" : ""}`}>{t("label:expense_account")}</div>
                </span>
                <Select
                    onSelect={onChange}
                    className="w-1/2"
                    showSearch
                    filterOption={doFilterSelect}
                    getPopupContainer={getPopupAnchor()}
                    value={expense.expenseAccount?._id}
                    loading={isLoading}
                    disabled={isInputDisabled}
                    defaultValue=""
                >
                    <Select.Option value="" disabled>
                        <div className="flex items-center overflow-hidden">
                            <span>-</span>
                        </div>
                    </Select.Option>
                    {expenseAccounts.map(({ accountName, accountCode, _id }, index) => (
                        <Select.Option key={index} value={_id} label={accountName} id={`expense-account-option-${_id}`}>
                            {accountCode} - {accountName}
                        </Select.Option>
                    ))}
                </Select>
            </li>
        )
    }

    return null
}
